<template>
    <div class="page-content">
        <div class="form-content">
            <div class="form-body">
                <div class="form-body-head">
                    <div class="head-item" @click="cIndex=1" :class="{'head-item-active': cIndex===1}">接机</div>
                    <div class="head-item" @click="cIndex=2" :class="{'head-item-active': cIndex===2}">送机</div>
                </div>
                <div class="form-body-content">
                    <el-form :model="form" :rules="rules" ref="forms" label-position="right" label-width="80px">
                        <el-form-item prop="flightNum" v-if="cIndex===1" label="航班号">
                            <el-input v-model="form.flightNum" placeholder="请输入航班号"></el-input>
                        </el-form-item>
                        <el-form-item label="城市" prop="area">
                            <el-select v-model="form.area" placeholder="请选择城市" filterable style="width: 100%;">
                                <el-option v-for="(item,index) in cityList"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="飞机场" prop="airport_select">
                            <el-select v-model="form.airport_select" placeholder="请选择飞机场" filterable style="width: 100%;">
                                <el-option v-for="(item,index) in airport"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="cIndex===1" label="目的地" prop="destination">
                            <el-input v-model="form.destination" placeholder="请输入目的地"></el-input>
                        </el-form-item>
                        <el-form-item v-if="cIndex===2" label="出发地" prop="destination">
                            <el-input v-model="form.destination" placeholder="请输入目的地"></el-input>
                        </el-form-item>
                        <el-form-item label="接机时间" prop="time">
                            <el-date-picker
                                    style="width: 100%;"
                                    v-model="form.time"
                                    value-format="yyyy/MM/dd HH:mm"
                                    format="yyyy/MM/dd HH:mm"
                                    type="datetime"
                                    placeholder="选择接机时间">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="人数">
                            <el-select v-model="form.population" placeholder="请选择人数" filterable style="width: 100%;">
                                <el-option v-for="(item,index) in numAry"
                                           :key="index"
                                           :label="`${item}人`"
                                           :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="行李">
                            <el-select v-model="form.luggage" placeholder="请选择行李" filterable style="width: 100%;">
                                <el-option label="无" :value="0"></el-option>
                                <el-option v-for="(item,index) in numAry"
                                           :key="index"
                                           :label="`${item}件`"
                                           :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <span class="color-red f-14" style="margin: 0 20px;">航班延误，可免费等待90分钟</span>
                            <el-button type="primary" @click="handlerSearch">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <img src="./../assets/img/word.png" alt="">
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {formVerify} from '@/utlis/decorators'
    export default {
        name: "shuttlePlane",
        data(){
            return {
                cIndex: 1,
                numAry: Array.from({length: 15}, (item, index)=> index + 1),
                form:{
                    flightNum: '',
                    area: '',
                    airport_select: '',
                    destination: '',
                    time: '',
                    population: 1,
                    luggage: 1
                },
                airport: [],
                rules: {
                    flightNum: [{ required: true, message: '请输入航班号', trigger: ['blur','change']}],
                    area: [{ required: true, message: '请选择城市', trigger: ['blur','change']}],
                    airport_select: [{ required: true, message: '请选择机场', trigger: ['blur','change']}],
                    destination: [{ required: true, message: '请输入目的地或出发地', trigger: ['blur','change']}],
                    time: [{ required: true, message: '请选择时间', trigger: ['blur','change']}],
                }
            }
        },
        computed:{
            ...mapState(['cityList'])
        },
        created(){
           this.getLandlordAdd()
        },
        methods:{
            async getLandlordAdd() {
                let [e, data] = await this.$api.getLandlordAddApi();
                if (data.code === 200) {
                    this.airport = data.result.airport;
                }
            },
            @formVerify('forms')
            handlerSearch(){
                let param = {
                    type: this.cIndex,
                    ...this.form
                }
                let data = encodeURIComponent(JSON.stringify(param))
                this.$router.push({path:'/shuttleResult',query:{data}})
            }
        }
    }
</script>

<style scoped lang="less">
    .page-content{
        width: 100%;
        height: 700px;
        background: url("./../assets/img/bannerBg.jpg") 100% 100% no-repeat;
        background-size: cover;
        .form-content{
            width: 1200px;
            height: 100%;
            margin: auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .form-body{
                background-color: #ffffff;
                box-shadow: 2px 2px 15px 2px rgba(0,0,0,.2);
                margin-left: 20px;
                width: 420px;
                min-height: 520px;
                border-radius: 10px;
                overflow: hidden;
                .form-body-head{
                    width: 100%;
                    height: 58px;
                    display: flex;
                    justify-content: center;
                    align-items: stretch;
                    .head-item{
                        flex: 1;
                        line-height: 58px;
                        color: #333333;
                        background-color: #e9e9e9;
                        cursor: pointer;
                        text-align: center;
                        font-weight: bold;
                    }
                    .head-item-active{
                        background-color: #ffffff;
                        color: #e44646;
                        text-align: center;
                    }
                }
                .form-body-content{
                    padding: 20px;
                }
            }
        }
    }
</style>
